import React, { useEffect, useState } from "react";
import api from "@/lib/api";

// Shared hook + component to render the branded logo/wordmark from settings.
export function useCinemaSettings() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/settings").then((r) => setS(r.data)).catch(() => setS({})); }, []);
  return s;
}

export default function CinemaBrand({ size = "md", stacked = true, className = "" }) {
  const s = useCinemaSettings();
  const logo = s?.logo_url ? absoluteUrl(s.logo_url) : "";
  const name = s?.cinema_name || "THE MOVIE HOUSE";
  const slogan = s?.slogan || "More Than Watching Movies.";
  const dim = { sm: "h-10", md: "h-16", lg: "h-24", xl: "h-32", "2xl": "h-48", "3xl": "h-64" }[size] || "h-16";
  const title = { sm: "text-lg", md: "text-2xl", lg: "text-4xl", xl: "text-5xl", "2xl": "text-6xl", "3xl": "text-7xl" }[size] || "text-2xl";
  const sub = { sm: "text-[9px]", md: "text-[10px]", lg: "text-xs", xl: "text-sm", "2xl": "text-base", "3xl": "text-lg" }[size] || "text-[10px]";
  // When we have a real logo image we shrink the wordmark to give the logo the stage.
  const hasLogo = !!logo;
  const titleCls = hasLogo ? (size === "3xl" ? "text-4xl" : size === "2xl" ? "text-3xl" : "text-xl") : title;
  return (
    <div className={`flex ${stacked ? "flex-col items-center text-center" : "flex-row items-center gap-4"} ${className}`}>
      {logo && <img src={logo} alt={name} className={`${dim} w-auto object-contain drop-shadow-[0_4px_24px_rgba(212,175,55,0.35)]`} onError={(e) => { e.currentTarget.style.display = "none"; }} />}
      <div>
        {!hasLogo && <div className={`font-heading ${title} text-[#D4AF37] tracking-wide leading-none`}>{name}</div>}
        {hasLogo && <div className={`font-heading ${titleCls} text-[#D4AF37]/50 tracking-widest leading-none uppercase`}>{name}</div>}
        <div className={`${sub} mt-2 uppercase tracking-[0.32em] text-[#A8A398]`}>{slogan}</div>
      </div>
    </div>
  );
}

function absoluteUrl(u) {
  if (!u) return "";
  if (u.startsWith("http")) return u;
  return `${process.env.REACT_APP_BACKEND_URL}${u}`;
}
